<template>
  <v-container fluid>
    <v-layout justify-center align-start v-if="!data || !data._id" class="printNone">
      <v-flex xl2 md4 sm6 xs12>
        <v-card class="br-10 pa-4 text-center">
            <div class="title pa-3">{{ $t('no_account_selected') }}</div>
            <v-layout row wrap pt-2 justify-center>
              <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" class="white--text" rounded type="button" large @click="$router.push('/'); resetData()">{{ $t('go_to_homepage') }}</v-btn>
            </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-list two-line class="br-10" dense v-if="data && data._id">
      <v-subheader><h3>{{ $t('ticket_info') }}</h3></v-subheader>
      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-bookmark fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data._id.split("-")[data._id.split("-").length - 1] }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('reference_no') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-calendar fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.created_at | dateTime }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('date') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-ticket fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2 text-uppercase">{{ `${data.ticket_type.code} - ${data.ticket_type.name}` }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('ticket_type') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-list-ul fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2 text-uppercase">{{ data.title }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('title') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-stack-exchange fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2" style="white-space: pre-line">
            {{ data.body }}
          </v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('content') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-info-circle fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2 text-uppercase" :class="{ 'green--text': data.status === 'new' }">
            <strong>{{ $t(data.status) }}</strong>
          </v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('status') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="data.ticket_department">
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-map-pin fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.ticket_department.name }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('department') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="data.ticket_status">
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-headphones fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.ticket_status.name }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('ticket_status') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <br>
    <v-list two-line class="br-10" dense v-if="data && data._id">
      <v-subheader><h3>{{ $t('customer_info') }}</h3></v-subheader>
      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-user-circle fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.customer_name }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('name', { field: '' }) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-id-card fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.customer_ic }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('ic_num', { field: '' }) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-phone fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.customer_phone }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('phone', { field: '' }) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-at fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.customer_email }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('email', { field: '' }) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <br>
    <v-card class="elevation-0 br-10">
      <v-list two-line class="br-10 text-center" dense>
        <v-subheader><h3>{{ $t('attachment') }}</h3></v-subheader>
        <v-divider></v-divider>
        <v-row v-if="images">
            <v-col sm="4" md="4" lg="2" xl="2" :key="i" v-for="(image, i) in images">
                <v-img aspect-ratio="1" :src="image" @click="index = i" style="cursor: pointer;" />
            </v-col>
        </v-row>
        <v-row v-if="pdf && !isCordova">
          <v-col sm="10" md="4" lg="2" xl="2" v-for="(doc, i) in pdf" :key="i" class="mt-5">
            <pdf :src="doc" :page="pageNum" @num-pages="numPages = $event" style="border: 2px solid black"></pdf>
            <div>
              <span>{{ pageNum }} / {{ numPages }}</span>
            </div>
          </v-col>
        </v-row>
        <vue-gallery :options="options" :images="images" :index="index" @close="index = null" />
      </v-list>
    </v-card>
  </v-container>
</template>

<script>
import axios from '../../axios'
import configuration from '../../configurations'
import VueGallery from 'vue-gallery'
import pdf from 'vue-pdf'

export default {
  beforeMount () {
    this.fetchData(this.$route.params.id)
  },
  data: () => ({
    data: {},
    images: [],
    pdf: [],
    index: null,
    options: { continuous: false },
    pdfUrl: '',
    pageNum: 1,
    numPages: null
  }),
  components: { VueGallery, pdf },
  computed: {
    isCordova () {
      return window.hasOwnProperty('cordova')
    }
  },
  methods: {
    async fetchData (id) {
      this.loading = true
      try {
        const response = await axios({
          url: `${configuration.WORKER}/tickets/${id}`,
          method: 'GET',
          params: {
            attachments: true
          }
        })
        this.data = response.data
        if (!this.data._attachments) return
        for (const name of Object.keys(this.data._attachments)) {
          if (this.data._attachments[name].content_type.startsWith('image')) {
            this.images.push(`data:${this.data._attachments[name].content_type};base64,${this.data._attachments[name].data}`)
          } else if (this.data._attachments[name].content_type === 'application/pdf') {
            this.pdf.push(`data:${this.data._attachments[name].content_type};base64,${this.data._attachments[name].data}`)
          }
        }
      } catch (error) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: 'Failed to fetch data.',
          visible: true
        })
        this.$router.go(-1)
      } finally {
        this.loading = false
      }
    },
    onPagePrev () {
      if (this.pageNum > 1) {
        this.pageNum--
      }
    },
    onPageNext () {
      if (this.pageNum < this.numPages) {
        this.pageNum++
      }
    }
  }
}
</script>
